import React, { Component, PropTypes } from "react"
import i18n from "lib/i18n"
import { DatePicker } from "components/shared/datePicker"
import styles from "./taskCreatorForm.scss"

// import tinyMCE. The 5.3 or above also requires importing a theme and a set of icons
import tinymce from 'tinymce/tinymce'
import 'tinymce/icons/default';
import 'tinymce/themes/silver'

// For tinyMCE 5.3 or above, the plugins are now imported here instead of being specified
// as external scripts
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/code'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/visualchars'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/table'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/preview'


const _ = i18n("taskCreator")

/**
 * TaskCreatorForm component
 *
 * implements the form to convert entities to task items
 ****************************************************************************************/
export default class TaskCreatorForm extends Component {
    static propTypes = {
        modalTitle: PropTypes.string.isRequired,
        taskItems: PropTypes.arrayOf(PropTypes.object),
        staffItems: PropTypes.arrayOf(PropTypes.object),
        convertionType: PropTypes.string.isRequired,
        taskCreatorModalToggle: PropTypes.func.isRequired,
        taskCreatorGenerateWithRelations: PropTypes.func.isRequired,
    }

    /**
     * Setup the default state of the component
     */
    constructor(props) {
        super(props)

        this.state = {
            isArchiveConfirmation: false,
            editors: {},

            taskItems: [],
            staffItems: [],
            convertionType: null
        }
    }

    /**
     * Generate a new array of data object without reference to the array of objects
     * @param {array} items the array of objects
     * @return {array} the new array object without reference
     */
    generateDataWithoutReference = ( items ) => {
        let newArray = []

        items.map((itemValue, itemKey) => {
            newArray[itemKey] = JSON.parse(JSON.stringify(itemValue))
        })

        return newArray
    }

    /**
     * On `componentWillMount` event updates the default state with the props received
     */
    componentWillMount() {
        let { taskItems, staffItems, convertionType } = this.props

        this.setState({
            taskItems: this.generateDataWithoutReference(taskItems),
            staffItems: this.generateDataWithoutReference(staffItems),
            convertionType: convertionType
        })
    }

    /**
     * On `componentDidMount` event binds the tinyMCE editor to each `textarea` element in the form
     * @see bindTinyMceEditor() the method that bind's the editor to textarea element
     */
    componentDidMount() {
        const { taskItems } = this.state

        if (taskItems && taskItems.length > 0) {
            taskItems.map((taskItem, taskItemKey) => {
                this.bindTinyMceEditor(taskItemKey)
            })
        }
    }

    /**
     * On `componentWillUnmount` event destorys each tinyMCE editor instance binded to `textarea` element
     * @see unbindTinyMceEditors() the method that destroys the editor instances foreach textarea element
     */
    componentWillUnmount() {
        this.unbindTinyMceEditors()
    }

    /**
     * Binds a tinyMCE editor instance to the textarea element of the task item
     * @param {int} taskItemKey the key of the taskItem from taskItems state data
     */
    bindTinyMceEditor = ( taskItemKey ) => {
        let editors = this.state.editors
        let elementSelector = `#tinymce-editor-${taskItemKey}`

        window.tinymce.init({
            selector: elementSelector,
            min_height: 365,
            menubar: false,
            mode: "design",
            statusbar: false,

            // [Jancsi] - these are not required anymore for version 5.3+ of tinyMCE, it is enough to specify the teme
            //theme_url: window.location.protocol+'//'+(window.location.href.split("/")[2] + '/themes/modern/theme.js').replace("\/\/", "\/"),
            //skin_url:  window.location.protocol+'//'+(window.location.href.split("/")[2] + '/skins/lightgray/').replace("\/\/", "\/"),
            theme : "silver",

            toolbar1 : "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | formatselect fontselect fontsizeselect",
            toolbar2 : "paste pastetext searchreplace | bullist numlist | outdent indent | undo redo | link unlink anchor image code",
            toolbar3 : "forecolor backcolor | table | hr removeformat visualchars | subscript superscript | charmap preview | fullscreen",
            // [Jancsi] these are not required anymore for version 5.3+ of tinyMCE, as plugins are imported at the beginning of the file
            // external_plugins: {
            //     'textcolor': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/textcolor/plugin.js').replace("\/\/", "\/"),
            //     'link': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/link/plugin.js').replace("\/\/", "\/"),
            //     //'image': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/image/plugin.js').replace("\/\/", "\/"),
            //     'code': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/code/plugin.js').replace("\/\/", "\/"),
            //     'searchreplace': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/searchreplace/plugin.js').replace("\/\/", "\/"),
            //     'paste': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/paste/plugin.js').replace("\/\/", "\/"),
            //     'visualchars': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/visualchars/plugin.js').replace("\/\/", "\/"),
            //     'charmap': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/charmap/plugin.js').replace("\/\/", "\/"),
            //     'table': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/table/plugin.js').replace("\/\/", "\/"),
            //     'fullscreen': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/fullscreen/plugin.js').replace("\/\/", "\/"),
            //     'preview': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/preview/plugin.js').replace("\/\/", "\/"),
            // },
            plugins : ["textcolor link code searchreplace paste visualchars charmap table fullscreen preview"],
            force_br_newlines: false,
            force_p_newlines: false,
            forced_root_block: "",
            relative_urls: false,
            remove_script_host: false,
            convert_urls: true,
            setup: editorInstance => {
                editors[elementSelector] = editorInstance
                editorInstance.on('init', (e) => {
                    this.initializeBodyEditor(editorInstance, taskItemKey)
                })

                this.setState({ editors: editors })
            }
        })
    }

    /**
     * Unbinds the tinyMCE editor for each element in the state.editors
     */
    unbindTinyMceEditors = () => {
        const { editors } = this.state

        if( editors && Object.keys(editors).length === 0) {
            return
        }

        Object.keys(editors).map(( editorId ) => {
            editorId = editorId.substr(1)

            window.tinymce.execCommand("mceFocus", true, editorId)
            window.tinymce.execCommand("mceRemoveEditor", true, editorId)
            window.tinymce.execCommand("mceRemoveControl", false, editorId)
        })
    }

    /**
     * Initialize an editor instance body
     * @param {object} editorInstance the tinyMCE editor instance
     * @param {int} taskItemKey the taskItem key
     */
    initializeBodyEditor = ( editorInstance, taskItemKey ) => {
        let { taskItems } = this.state
        let taskItem = taskItems[taskItemKey]

        if( window.tinymce && editorInstance ) {

            try {
                editorInstance.setContent(taskItem.description, {format: 'raw'})
            } catch(exc) {
                console.log(exc)
            }

            editorInstance.on('blur', (e) => {
                this.taskItemDescriptionChangeHandler(taskItemKey,editorInstance.getContent())
            })

            editorInstance.on('click', (e) => {
                this.taskItemDescriptionChangeHandler(taskItemKey,editorInstance.getContent())
            })
        }
    }

    /**
     * Changes the title in the state for the requested taskItem based on `itemKey`
     * @param {int} itemKey the key of the changed item
     * @param {object} event the event data
     */
    taskItemTitleChangeHandler = ( itemKey, event ) => {
        const taskItems = this.state.taskItems

        if (taskItems[itemKey]) {
            taskItems[itemKey].title = event.target.value
        }

        this.setState({ taskItems: taskItems })
    }

    /**
     * Changes the description in the state for the requested taskItem based on `itemKey`
     * @param {int} itemKey the key of the changed item
     * @param {mixed} value the new value
     */
    taskItemDescriptionChangeHandler = ( itemKey, value ) => {
        let taskItems = this.state.taskItems

        if (taskItems[itemKey]) {
            taskItems[itemKey].description = value
        }

        this.setState({ taskItems: taskItems })
    }

    /**
     * Changes the date in the state for the requested taskItem based on `itemKey`
     * @param {int} itemKey the key of the changed item
     * @param {string} event the changed date value
     */
    taskItemDateChangeHandler = (itemKey, event) => {
        const taskItems = this.state.taskItems

        if (taskItems[itemKey]) {
            taskItems[itemKey].endDate = event
        }

        this.setState({ taskItems: taskItems })
    }

    /**
     * Toggles a staff item selected property based on `staffId`
     * @param {int} staffId the id of the staff item `userId` property in the staff shape
     */
    staffItemSelectionHandler = staffId => {
        let staffItems = this.state.staffItems
        let selection = []

        staffItems.map((value, key) => {
            selection[key] = { ...value }

            if (value.userId == staffId) {
                selection[key].selected = !value.selected
            }
        })

        this.setState({ staffItems: selection })
    }

    /**
	 * Handles the archive confirmation input change event
	 * this is used to check if the user wants to archive the entities that will be converted to tasks
	 */
	handleArchiveConfirmationInput() {
		const {isArchiveConfirmation} = this.state

		this.setState({isArchiveConfirmation: !isArchiveConfirmation})
	}

    /**
     * Handles the modal submition event
     */
    handleModalSubmitEvent = () => {
        const { taskCreatorGenerateWithRelations } = this.props
		const { taskItems, staffItems, isArchiveConfirmation, convertionType } = this.state

		taskCreatorGenerateWithRelations({
			items: taskItems,
			users: staffItems,
            isArchiveConfirmation: isArchiveConfirmation,
            convertionType: convertionType
		})
    }

    render() {
        const { modalTitle, error, statusText, taskCreatorModalToggle } = this.props
        const { taskItems, staffItems, isArchiveConfirmation, convertionType } = this.state

        const canSubmitForm = staffItems.reduce((a, b) => a + (b.selected ? 1 : 0), 0)

        return (
            <div className={styles.modalContent}>
                <span className={styles.modalTitle}>{_(modalTitle)}</span>

                {/*#list [taskItems]*/}
                <div className={styles.taskItemsList}>
                    {taskItems.length > 0 &&
                        taskItems.map((taskItem, key) => (
                            <div className={styles.taskItem} key={key}>
                                <div className={styles.taskField}>
                                    <label>{_("modalTaskTitle")}</label>
                                    <input
                                        type="text"
                                        value={taskItem.title}
                                        onChange={(event) => this.taskItemTitleChangeHandler(key,event)}
                                    />
                                </div>

                                <div className={styles.taskField}>
                                    <label>{_("modalTaskDescription")}</label>
                                    <textarea id={`tinymce-editor-${key}`} />
                                </div>

                                <div
                                    className={
                                        styles.taskField +
                                        " " +
                                        styles.dateInput
                                    }
                                >
                                    <label>{_("modalTaskEndate")}</label>
                                    <DatePicker
                                        value={taskItem.endDate}
                                        onChange={ev => this.taskItemDateChangeHandler(key,ev)}
                                    />
                                </div>
                            </div>
                        ))}
                </div>
                {/*#endlist*/}

                {/*#list [staffItems]*/}
                <div className={styles.modalSubtitle}>{_("selectUsers")}</div>
                <ul className={styles.staffItemsList}>
                    {staffItems.map((staffItem, key) => (
                        <li
                            key={staffItem.userId}
                            data-selected={staffItem.selected}
                            onClick={() => this.staffItemSelectionHandler(staffItem.userId)}
                        >
                            <span>
                                {staffItem.firstName + " " + staffItem.lastName}
                            </span>

                            <span>{staffItem.email}</span>
                        </li>
                    ))}
                </ul>
                {/*endlist*/}

                {/*#region [archiveConfirmation]*/}
                {convertionType !== 'task' && <div className={styles.archiveSubtitleLast}>
					<label htmlFor="confirm-archive-item">{_('archiveConfirmation')}</label>
					<input
						type="checkbox"
						id="confirm-archive-item"
						onChange={(ev) => this.handleArchiveConfirmationInput(ev)}
						value={isArchiveConfirmation}
					/>
				</div>}
                {/*#endregion*/}

                <div className={styles.error}>{(statusText == "ValidationError") ? _("validationError") : error}</div>

                {/*#region [modalControlls]*/}
                <div className={styles.modalActions}>
                    <span
                        onClick={() => taskCreatorModalToggle()}
                        className={styles.closeButton}
                    >
                        {_("cancel")}
                    </span>
                    <input
                        onClick={() => this.handleModalSubmitEvent()}
                        type="button"
                        className={styles.greyButton}
                        value={_("sendAsTask")}
                        disabled={!canSubmitForm}
                    />
                </div>
                {/*#endregion*/}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/taskCreator/taskCreatorForm.jsx